/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Container, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import MonitorGroupAccordion from "../Components/Accordion/MonitorGroupAccordion";

/**
 * Monitor component
 * Description: This component is used to display the monitor groups in the accordion
 */
function Monitor({ monitorGroup, availabilityHistory }) {

  return (
    <Container sx={ { my: 4 } }>
      <Typography variant="h6" style={ { fontWeight: 400 } } sx={ { pb: 2 } }>
        Services Summary
      </Typography>
      { monitorGroup.length > 0 && (
        <Paper variant="elevation" elevation={ 8 }>
          { monitorGroup.map((group, index) => (
            <MonitorGroupAccordion
              key={ group.display_name }
              group={ group }
              subgroup={ group.subgroups }
              availabilityHistory={
                availabilityHistory.length > 0 &&
                availabilityHistory.find(item => item?.display_name == group.display_name)?.subgroups || [] }
              isExpanded={ index === 0 }
            />
          )) }
        </Paper>
      ) }
    </Container>
  );
}

Monitor.propTypes = {
  availabilityHistory: PropTypes.array,
  monitorGroup: PropTypes.array
};

export default Monitor;
